<template>
  <div id="app">
    <navbar-page></navbar-page>
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
    <footer-page></footer-page>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
export default {
    mounted () {
      this.$Progress.finish()
    },
    created () {
      this.$Progress.start()
      this.$router.beforeEach((to, from, next) => {
        if (to.meta.progress !== undefined) {
          let meta = to.meta.progress
          this.$Progress.parseMeta(meta)
        }
        this.$Progress.start()
        next()
      })
      this.$router.afterEach((to, from) => {
        this.$Progress.finish()
      })
    }
}
</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
    opacity: 0
    }
</style>
